import { useMutation } from "@tanstack/react-query";
import { apiClient, ApiResponse } from "@/core/api/axios-client";
import { TokenStorage } from "@/core/api/storage";
import type { LoginRequest, LoginResponseData } from "@/core/api/types/auth";
import toast from "react-hot-toast";

// ============================================================================
// useLogin - POST /v2/application_login_single_step/
// Nota: questo endpoint è fuori da /v2/corsi, quindi usiamo URL assoluto
// ============================================================================
const LOGIN_URL = `${import.meta.env.VITE_API_URL}/v2/application_login_single_step/`;

export const useLogin = () => {
  return useMutation({
    mutationFn: async (credentials: LoginRequest) => {
      const response = await apiClient.post<ApiResponse<LoginResponseData>>(
        LOGIN_URL,
        credentials
      );

      // Salva i token (mappa jwt_token -> accessToken)
      TokenStorage.setTokens({
        accessToken: response.data.data.jwt_token,
        refreshToken: response.data.data.refresh_token,
      });

      return response.data;
    },
    onError: (error: any) => {
      const message = error.response?.data?.message || "Errore durante il login";
      toast.error(message);
    },
  });
};

// ============================================================================
// useLogout - Locale (pulisce storage)
// ============================================================================
export const useLogout = () => {
  return useMutation({
    mutationFn: async () => {
      TokenStorage.removeTokens();
      return { success: true };
    },
  });
};

// ============================================================================
// Stub temporanei - TODO: implementare quando avremo gli endpoint
// ============================================================================
export const useForgotPassword = () => {
  return useMutation({
    mutationFn: async (_data: { email: string }) => {
      throw new Error("Endpoint non ancora implementato");
    },
  });
};

export const useResetPassword = () => {
  return useMutation({
    mutationFn: async (_data: { token: string; password: string; passwordConfirmation: string }) => {
      throw new Error("Endpoint non ancora implementato");
    },
  });
};

export const useVerifyResetToken = () => {
  return useMutation({
    mutationFn: async (_data: { token: string }) => {
      throw new Error("Endpoint non ancora implementato");
    },
  });
};
